module.exports = __webpack_public_path__ + "img/chongzhi-detail.f3d5f982.png";